(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cw-measurement-guide"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){const button=event.target.closest('[data-cw-choice]');if(!button)return;const root=button.closest('.cw-measure');if(!root)return;root.querySelectorAll('[data-cw-choice]').forEach(function(tab){tab.setAttribute('aria-selected',String(tab===button));});root.querySelectorAll('[data-cw-panel]').forEach(function(panel){panel.hidden=panel.dataset.cwPanel!==button.dataset.cwChoice;});});document.addEventListener('keydown',function(event){const button=event.target.closest('[data-cw-choice]');if(!button||!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;event.preventDefault();const tabs=Array.from(button.closest('.tabs').querySelectorAll('[data-cw-choice]'));const index=tabs.indexOf(button);const next=event.key==='Home'?0:event.key==='End'?tabs.length-1:(index+(event.key==='ArrowRight'?1:-1)+tabs.length)%tabs.length;tabs[next].focus();tabs[next].click();});
  } catch(e) { console.error(e); }
})();

})();
